require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-hayley-da-costa.json") })
        }
      }, "path---authors-hayley-da-costa");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-hayley-da-costa!./.cache/json/authors-hayley-da-costa.json
// module id = 1285
// module chunks = 231608221292675